import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import PaywallModal from "./components/feature/PaywallModal";
import PaymentSuccessHandler from "./components/feature/PaymentSuccessHandler";
import CookieBanner from "./components/feature/CookieBanner";
import LoginStreakBanner from "./components/feature/LoginStreakBanner";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <PaywallModal />
          <PaymentSuccessHandler />
          <CookieBanner />
          <LoginStreakBanner />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
